<template>
  <div class="d-flex full-width align-start" style="height:98px">
        <table class="full-width text-left"  >
          <tr>
            <th class="px-2" style="width: 120px">Dienst</th>
            <th class="px-2" style="width: 50px">Linie</th>
            <th class="px-2" style="width: 50px">Kurs</th>
            <th class="px-2" style="width: 100px">von</th>
            <th class="px-2" style="width: auto">bis</th>
          </tr>
          <tr v-for="(da, ind) in selectedDutyParts" :key="ind" class="text-no-wrap">
            <td>
              <div class="text-center" :style="{ background: colorPalette[ind] }" style="border-radius: 20px">
                {{ da.dutyPartName }}
              </div>
            </td>

            <td class="px-2">{{ da.line }}</td>

            <td class="px-2">{{ da.course }}</td>

            <td class="px-2">{{ da.from }} {{ da.fromLocation }}</td>

            <td class="px-2">
              {{ da.to }}
              {{ da.toLocation }}
            </td>
          </tr>
        </table>
  </div>
</template>
<script>
import dateUtils from '@/common/dateUtils';
import { mapState } from 'vuex';
import wsMixin from "@/modules/customerVbzWorksheet/wsMixin";

export default {
  
  name: 'DutyPartsSelectionResult',
  mixins: [wsMixin],
  props: {
    selectedDutyParts: Array,
  },
};
</script>
